import React from "react";
import { Form, Icon, Input, Checkbox, Radio, Select } from "antd";

import PatientElectronicText from "./Texts/PatientElectronicText";
import SurrogateElectronicText from "./Texts/SurrogateElectronicText";
import PatientAfterDeferralElectronicText from "./Texts/PatientAfterDeferralElectronicText";
import SurrogateAfterDeferralElectronicText from "./Texts/SurrogateAfterDeferralElectronicText";
import EmergencyElectronicText from "./Texts/EmergencyElectronicText";
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class ConsentMevoStep3aPatient extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const site_001 = '001';
    const site_025 = '025';
    const site_026 = '026';
    const site_030 = '030';
    const site_27 = '027';
    const site_40 = '040';

    let isEmail = false;
    let isAfterDeferral = false;
    if (props.consentMethodType){
      isEmail = props.consentMethodType.includes('Email');
      isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    }

    const showForEmail = !(isEmail && !props.token); // is also true if consent electronic
    const isPatient = props.consentPersonType === "Patient";
    const isEmergency = props.consentPersonType === "Emergency";
    const isSurrogate = props.consentPersonType === "Surrogate";
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";
    const isInvestigatorFirst = props.email_consent_signature_order === "investigator_first";
    const isEmailParticipant = props.signature_type === "participant";
    const isEmailInvestigator = props.signature_type === "investigator";

    let preNameOfParticipant = '';
    let NameOfParticipant = 'Name of Participant';
    let SignatureOfParticipant = 'Signature of Participant';
    let NameOfSurrogate = 'Name of Surrogate';
    let SignatureOfSurrogate = 'Signature of Surrogate';
    let RelationshiptoParticipant = 'Relationship to Participant';
    let NameofPersonObtainingConsent = 'Name of Person Obtaining Consent';
    let SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';

    if ([site_025, site_026, site_030].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      NameOfSurrogate = 'Printed Name of adult subject capable of consent';
      SignatureOfSurrogate = 'Signature of adult subject capable of consent';
      NameofPersonObtainingConsent = 'Printed Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';
    }

    if ([site_40].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      NameOfParticipant = 'Name of Participant';
      SignatureOfParticipant = 'Signature of Participant';
      NameOfSurrogate = 'Name of Legally Authorized Representative';
      SignatureOfSurrogate = 'Signature of Legally Authorized Representative';
      NameofPersonObtainingConsent = 'Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';
    }

    let QuestionNr1Text = props.i18n.t('NamespaceConsentLhsStep3aPatient:CONSENT TO CONTACT YOU IF RESEARCHERS DISCOVER SOMETHING ABOUT YOU:');
    if (isSurrogate){
      QuestionNr1Text = props.i18n.t('NamespaceConsentLhsStep3aPatient:CONSENT TO CONTACT IF RESEARCHERS DISCOVER SOMETHING ABOUT YOUR FAMILY MEMBER:');
    }
    if ([site_025, site_026, site_030].includes(props.site_code)){
      QuestionNr1Text = props.i18n.t('NamespaceConsentLhsStep3aPatient:CONSENT TO CONTACT YOU IF RESEARCHERS DISCOVER NEW INFORMATION AFTER YOUR PARTICIPATION ENDS:');
    }

    if ([site_026].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      if (isSurrogate) {
        NameOfSurrogate = 'Name of Legally Authorized Representative (LAR)';
        SignatureOfSurrogate = 'Signature of Legally Authorized Representative (LAR)';
        RelationshiptoParticipant = 'LAR relationship to participant';
      }
    }

    if ([site_025].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      if (isSurrogate) {

        NameOfParticipant = 'Name of Trial Participant';
        NameOfSurrogate = 'Name of LAR';
        SignatureOfSurrogate = 'Signature of LAR';
        RelationshiptoParticipant = 'Relationship to Trial Participant';
      }
    }

    if ([site_030].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      if (isSurrogate) {
        NameOfParticipant = 'Name of Trial Participant';
        NameOfSurrogate = 'Name of Legally Authorized Representative (LAR)';
        SignatureOfSurrogate = 'Signature of Legally Authorized Representative (LAR)';
        RelationshiptoParticipant = 'Relationship to Trial Participant';
      }
    }

    if ([site_27].includes(props.site_code)) {
      NameOfParticipant = 'Printed Name of Participant';
      NameofPersonObtainingConsent = 'Printed Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';

      if (isSurrogate) {
        NameOfSurrogate = 'Printed Name of Legally Authorized Representative';
        SignatureOfSurrogate = 'Signature of Legally Authorized Representative';
        RelationshiptoParticipant = 'Relationship to Trial Participant';
      }
    }

    return (
      <div className="form-group consent-form-ui">
        <style>
          {".consent-form-ui h1, h2, h3, h4, h5, h6 {text-transform: none;}"}
        </style>
        <h4>
          {props.signature_type === "investigator"
            ? this.props.i18n.t(
                "NamespaceConsentStep3aPatient:Consent Process - Investigator"
              )
            : props.consentPersonType === "Surrogate"
            ? this.props.i18n.t(
                "NamespaceConsentStep3aPatient:Consent Process - Surrogate"
              )
            : props.consentPersonType === "Patient"
            ? this.props.i18n.t(
                "NamespaceConsentStep3aPatient:Consent Process - Patient"
              )
            : props.consentPersonType === "Emergency"
            ? this.props.i18n.t(
                "NamespaceConsentStep3aPatient:Consent Process - Emergency"
              )
            : ""}
        </h4>

        <div className="form-group-details">
          {props.siteID && (
            <h5>
              {this.props.i18n.t("Site ID")}: <b>{props.siteID}</b>
            </h5>
          )}
          {props.userID && (
            <h5>
              {this.props.i18n.t("User ID")}: <b>{props.userID}</b>
            </h5>
          )}
          <h5>
            {this.props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
          </h5>
        </div>

        {isEmergency ? <EmergencyElectronicText {...props} /> : isAfterDeferral ? (props.consentPersonType === "Surrogate" ? (
          <SurrogateAfterDeferralElectronicText {...props} />
        ) : (
          <PatientAfterDeferralElectronicText {...props} />
        )) : props.consentPersonType === "Surrogate" ? (
          <SurrogateElectronicText {...props} />
        ) : (
          <PatientElectronicText {...props} />
        )}

        <p>
          <strong>
            {this.props.i18n.t("Server Date (UTC)")}:{" "}
            {props.date || props.consentDate}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Type")}: {props.consentPersonType}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Method")}: {props.consentMethodType}
          </strong>
        </p>
        <p>&nbsp;</p>

        <div style={{ textAlign: "left" }}>
          {showForEmail && !isEmergency && (
            <div>
              <br/>
              {[site_40].includes(props.site_code) && <div>
                <Form.Item>
                  <label>

                    <div className='form-label'><b>CONSENT TO CONTACT YOUR FAMILY DOCTOR:</b></div>
                    {props.form.getFieldDecorator('consent_question_contact_my_family_doctor', {
                      initialValue: props.consent_question_contact_my_family_doctor,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Radio.Group disabled={props.signature_type === "investigator"}>
                        <Radio value={true}>
                          Yes, I consent for my family doctor to be informed of my participation.
                        </Radio>
                        <br/>
                        <Radio value={false}>
                          No, I do not consent for my family doctor to be informed of my participation.
                        </Radio>
                      </Radio.Group>
                    )}
                  </label>
                </Form.Item>

                <div>
                  <div>PCP/ Healthcare Provider:</div>
                  <br/>
                  <Form.Item>
                    <label>
                      <div className="form-label">
                        Name
                      </div>
                      {props.form.getFieldDecorator("extra_field_healthcare_provider_name", {
                        initialValue: props.extra_field_healthcare_provider_name,
                        rules: [
                          {
                            required: false,
                            message: "Required",
                          },
                        ],
                      })(
                        <Input placeholder='Name' disabled={props.signature_type === "investigator"}/>
                      )}
                    </label>
                  </Form.Item>
                  <Form.Item>
                    <label>
                      <div className="form-label">
                        Address
                      </div>
                      {props.form.getFieldDecorator("extra_field_healthcare_provider_address", {
                        initialValue: props.extra_field_healthcare_provider_address,
                        rules: [
                          {
                            required: false,
                            message: "Required",
                          },
                        ],
                      })(
                        <Input placeholder='Address' disabled={props.signature_type === "investigator"}/>
                      )}
                    </label>
                  </Form.Item>
                  <Form.Item>
                    <label>
                      <div className="form-label">
                        City/State/Zip
                      </div>
                      {props.form.getFieldDecorator("extra_field_healthcare_provider_city_state_zip", {
                        initialValue: props.extra_field_healthcare_provider_city_state_zip,
                        rules: [
                          {
                            required: false,
                            message: "Required",
                          },
                        ],
                      })(
                        <Input placeholder='City/State/Zip' disabled={props.signature_type === "investigator"}/>
                      )}
                    </label>
                  </Form.Item>
                  <Form.Item>
                    <label>
                      <div className="form-label">
                        Phone and Fax numbers
                      </div>
                      {props.form.getFieldDecorator("extra_field_healthcare_provider_contact_numbers", {
                        initialValue: props.extra_field_healthcare_provider_contact_numbers,
                        rules: [
                          {
                            required: false,
                            message: "Required",
                          },
                        ],
                      })(
                        <Input placeholder='Phone and Fax numbers' disabled={props.signature_type === "investigator"}/>
                      )}
                    </label>
                  </Form.Item>
                </div>
                <br/>
              </div>}

              {(isAfterDeferral || [site_40].includes(props.site_code)) && <Form.Item>
                <label>
                  <div className="form-label">
                    <b>{this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:Please check the appropriate box to indicate your decision"
                    )}:</b>
                  </div>
                  {props.form.getFieldDecorator("consent_option", {
                    initialValue: props.consent_option,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Radio.Group
                      disabled={props.signature_type === "investigator"}
                    >
                      <Radio value="stay_in_study">
                        {this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:I wish to stay in the study."
                        )}
                      </Radio>
                      <br />
                      <Radio value="withdraw_from_study">
                        {this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:I wish to withdraw from the study"
                        )}
                      </Radio>
                    </Radio.Group>
                  )}
                </label>
              </Form.Item>}

              {![site_27, site_40].includes(props.site_code) && <div>
                <Form.Item>
                  <label>

                    <div className='form-label'>{QuestionNr1Text}</div>
                    {props.form.getFieldDecorator('consent_question_researchers_share_findings_with_me', {
                      initialValue: props.consent_question_researchers_share_findings_with_me,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Radio.Group disabled={props.signature_type === "investigator"}>
                        <Radio value={true}>
                          Yes, I consent for the researchers to share findings with me.
                        </Radio>
                        <br/>
                        <Radio value={false}>
                          No, I do not consent for the researchers to share findings with me.
                        </Radio>
                      </Radio.Group>
                    )}
                  </label>
                </Form.Item>

                <Form.Item>
                  <label>
                    <div className='form-label'>CONSENT TO USE OF DATA AND SPECIMENS FOR FUTURE RESEARCH:</div>
                    {props.form.getFieldDecorator('consent_question_use_my_research_data', {
                      initialValue: props.consent_question_use_my_research_data,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Radio.Group disabled={props.signature_type === "investigator"}>
                        <Radio value={true}>
                          Yes, I consent to the use of research data and /or specimens for future research.
                        </Radio>
                        <br/>
                        <Radio value={false}>
                          No, I do not consent to the use of research data and /or specimens for future research.
                        </Radio>
                      </Radio.Group>
                    )}
                  </label>
                </Form.Item>

                <Form.Item>
                  <label>
                    <div className='form-label'>CONSENT TO CONTACT YOU FOR FUTURE RESEARCH/INFORMATION:</div>
                    {/*<div style={{ margin: '0 0 5px' }}>
                      My research data may be kept for use in future research to learn about, prevent or treat other health-related problems.
                      <br/>
                      Additional blood/urine may be taken for this research, as described in the consent form.
                    </div>*/}
                    {props.form.getFieldDecorator('consent_question_future_contact', {
                      initialValue: props.consent_question_future_contact,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Radio.Group disabled={props.signature_type === "investigator"}>
                        <Radio value={true}>
                          Yes, I consent to be contacted in the future.
                        </Radio>
                        <br/>
                        <Radio value={false}>
                          No, I do not consent to be contacted in the future.
                        </Radio>
                      </Radio.Group>
                    )}
                  </label>
                </Form.Item>

                <Form.Item>
                  <label>
                    <div className='form-label'>{isSurrogate ? "CONSENT TO CONTACT YOUR FAMILY MEMBER'S DOCTOR" : 'CONSENT TO CONTACT YOUR FAMILY DOCTOR'}:</div>
                    {props.form.getFieldDecorator('consent_question_contact_my_family_doctor', {
                      initialValue: props.consent_question_contact_my_family_doctor,
                      rules: [{
                        required: true,
                        message: 'Required'
                      }],
                    })(
                      <Radio.Group disabled={props.signature_type === "investigator"}>
                        <Radio value={true}>
                          Yes, I consent for the family doctor to be informed of the participation.
                        </Radio>
                        <br/>
                        <Radio value={false}>
                          No, I do not consent for the family doctor to be informed of the participation.
                        </Radio>
                      </Radio.Group>
                    )}
                  </label>
                </Form.Item>
              </div>}
            </div>
          )}
          <br />
          {[site_025, site_030].includes(props.site_code) && isSurrogate && <p>Assent of participants unable to consent is NOT required</p>}

          <br />

          {preNameOfParticipant && <div style={{ marginBottom: '15px' }}>{preNameOfParticipant}</div>}

          {[site_40].includes(props.site_code) && <h5><b>SIGNATURE OF STUDY PARTICIPANT</b></h5>}
          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(NameOfParticipant)}
              </div>
              {props.form.getFieldDecorator("consent_subject_full_name", {
                initialValue: props.consent_subject_full_name,
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: "#000" }} />}
                  placeholder={this.props.i18n.t(NameOfParticipant)}
                />
              )}
            </label>
          </Form.Item>

          {!isEmail && <div>
            <Form.Item>
              {props.form.getFieldDecorator("email_consent_copy_to_subject", {
                initialValue: false,
                valuePropName: "checked",
              })(
                <Checkbox>
                  {this.props.i18n.t(
                    "NamespaceConsentStep3aPatient:Send copy of consent via email"
                  )}
                </Checkbox>
              )}
            </Form.Item>

            {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:Patient Email"
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_subject_email", {
                    initialValue: props.consent_subject_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Please enter the participant's email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
          </div>}

          {isEmail && isSurrogate && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentStep3aPatient:Substitute Decision Maker Email"
                  )}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}
          {isEmail && isPatient && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t("Participant Email")}
                </div>
                {props.form.getFieldDecorator("consent_subject_email", {
                  initialValue: props.consent_subject_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Please enter the participant's email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}

          {isPatient && (!isEmail || props.signature_type === "participant") && (
              <div>
                <Signature
                  fieldName="consent_subject_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:${SignatureOfParticipant}`
                  )}
                  form={props.form}
                />
              </div>
            )}

          {props.consentPersonType === "Surrogate" && (
            <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      `NamespaceConsentStep3aPatient:${NameOfSurrogate}`
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_surrogate_full_name", {
                    initialValue: props.consent_surrogate_full_name,
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input
                      disabled={props.signature_type === "investigator"}
                      prefix={<Icon type="user" style={{ color: "#000" }} />}
                      placeholder={this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:${NameOfSurrogate}`
                      )}
                    />
                  )}
                </label>
              </Form.Item>


              {![site_27, site_40].includes(props.site_code) && <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      `NamespaceConsentStep3aPatient:${RelationshiptoParticipant}`
                    )}
                  </div>
                  {props.form.getFieldDecorator(
                    "consent_surrogate_relationship",
                    {
                      initialValue: props.consent_surrogate_relationship,
                    }
                  )(
                    <Input
                      disabled={props.signature_type === "investigator"}
                      placeholder={this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:${RelationshiptoParticipant}`
                      )}
                    />
                  )}
                </label>
              </Form.Item>}

              {(!isEmail || props.signature_type === "participant") && (
                <Signature
                  fieldName="consent_surrogate_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:${SignatureOfSurrogate}`
                  )}
                  form={props.form}
                />
              )}
            </div>
          )}

          {props.signature_type === "investigator" && props.consent_subject_signature && isPatient && <img src={props.consent_subject_signature} width={250} alt='Subject Signature' />}
          {props.signature_type === "investigator" && props.consent_surrogate_signature && isSurrogate && <img src={props.consent_surrogate_signature} width={250} alt='Subject Signature' />}

          <div>

            {props.site_code !== site_025 && <div>

                {[site_40].includes(props.site_code) && <h5><b>SIGNATURE OF PERSON OBTAINING CONSENT</b></h5>}
                <Form.Item>
                  <label>
                    <div className="form-label">
                      {this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:${NameofPersonObtainingConsent}`
                      )}
                    </div>
                    {props.form.getFieldDecorator(
                      "consent_investigator_full_name",
                      {
                        initialValue: props.consent_investigator_full_name,
                        rules: [
                          {
                            required: true,
                            message: "Required",
                          },
                        ],
                      }
                    )(
                      <Input
                        disabled={props.token}
                        prefix={<Icon type="user" style={{ color: "#000" }} />}
                        placeholder={this.props.i18n.t(
                          `NamespaceConsentStep3aPatient:${NameofPersonObtainingConsent} (print)`
                        )}
                      />
                    )}
                  </label>
                </Form.Item>
                <Form.Item>
                  <label>
                    <div className="form-label">
                      {this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Person Obtaining Consent Contact Number"
                      )}
                    </div>
                    {props.form.getFieldDecorator(
                      "consent_investigator_contact_number",
                      {
                        initialValue: props.consent_investigator_contact_number || ([site_001].includes(props.site_code) ? "4039442863" : ""),
                        rules: [
                          {
                            required: true,
                            message: "Required",
                          },
                        ],
                      }
                    )(
                      <Input
                        disabled={props.token}
                        placeholder={this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Person obtaining consent contact number"
                        )}
                      />
                    )}
                  </label>
                </Form.Item>
              </div>
            }

            {props.site_code === site_025 && <div>
                <Form.Item>
                  <label>
                    <div className="form-label">
                      {this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:${NameofPersonObtainingConsent}`
                      )}
                    </div>
                    {props.form.getFieldDecorator(
                      "consent_obtainer_full_name",
                      {
                        initialValue: props.consent_obtainer_full_name,
                        rules: [
                          {
                            required: true,
                            message: "Required",
                          },
                        ],
                      }
                    )(
                      <Input
                        disabled={props.token}
                        prefix={<Icon type="user" style={{ color: "#000" }} />}
                        placeholder={this.props.i18n.t(
                          `NamespaceConsentStep3aPatient:${NameofPersonObtainingConsent} (print)`
                        )}
                      />
                    )}
                  </label>
                </Form.Item>
                <Form.Item>
                  <label>
                    <div className="form-label">
                      {this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Person Obtaining Consent Contact Number"
                      )}
                    </div>
                    {props.form.getFieldDecorator(
                      "consent_obtainer_contact_number",
                      {
                        initialValue: props.consent_obtainer_contact_number,
                        rules: [
                          {
                            required: true,
                            message: "Required",
                          },
                        ],
                      }
                    )(
                      <Input
                        disabled={props.token}
                        placeholder={this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Person obtaining consent contact number"
                        )}
                      />
                    )}
                  </label>
                </Form.Item>
              </div>
            }




            {isEmail && isSubjectFirst && !props.signature_type && (
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t("Person Obtaining Consent Email")}
                  </div>
                  {props.form.getFieldDecorator("consent_investigator_email", {
                    initialValue: props.consent_investigator_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Person Obtaining Consent Email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            )}

            {(!isEmail ? true : (isSubjectFirst ? props.signature_type === "investigator" : !props.token)) && (

              <div>
                {![site_025].includes(props.site_code) &&
                  <Signature
                    fieldName="consent_investigator_signature"
                    label={this.props.i18n.t(
                      `NamespaceConsentStep3aPatient:${SignatureOfPersonObtainingConsent}`
                    )}
                    form={props.form}
                  />
                }

              {[site_025].includes(props.site_code) &&
                <Signature
                  fieldName="consent_obtainer_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:${SignatureOfPersonObtainingConsent}`
                  )}
                  form={props.form}
                />
              }

              </div>
            )}
          </div>

          {props.site_code === site_025 && <div>
            <div>
              <h5>CERTIFICATE OF INVESTIGATOR</h5>
              <p style={{ marginBottom: '15px' }}>I certify that this subject has been consented</p>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      `NamespaceConsentStep3aPatient:Printed Name of Investigator`
                    )}
                  </div>
                  {props.form.getFieldDecorator(
                    "consent_investigator_full_name",
                    {
                      initialValue: props.consent_investigator_full_name,
                      rules: [
                        {
                          required: true,
                          message: "Required",
                        },
                      ],
                    }
                  )(
                    <Input
                      disabled={props.token}
                      prefix={<Icon type="user" style={{ color: "#000" }} />}
                      placeholder={this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:Printed Name of Investigator`
                      )}
                    />
                  )}
                </label>
              </Form.Item>
            </div>

            {(!isEmail ? true : (isSubjectFirst ? props.signature_type === "investigator" : !props.token)) && (
              <Signature
                fieldName="consent_investigator_signature"
                label={this.props.i18n.t(
                  `NamespaceConsentStep3aPatient:Signature of Investigator`
                )}
                form={props.form}
              />
            )}
          </div>}

          {!isEmail && (
            <div>
              {![site_27].includes(props.site_code) && (
                  <div>
                    {[site_40].includes(props.site_code) && <div>
                      <h5><b>SIGNATURE OF THE WITNESS</b></h5>
                      <div>
                        Used in cases where the participant or LAR is illiterate, or the short form consent process is
                        needed.
                        <br/>
                        <br/>
                      </div>
                    </div>}
                    <Form.Item>
                      <label>
                        <div className="form-label">
                          {this.props.i18n.t(
                            "NamespaceConsentStep3aPatient:Witness Name (if applicable)"
                          )}
                        </div>
                        {props.form.getFieldDecorator(
                          "consent_witness_full_name",
                          {
                            initialValue: props.consent_witness_full_name,
                          }
                        )(
                          <Input
                            prefix={
                              <Icon type="user" style={{ color: "#000" }} />
                            }
                            placeholder={this.props.i18n.t(
                              "NamespaceConsentStep3aPatient:Witness Name (if applicable)"
                            )}
                          />
                        )}
                      </label>
                    </Form.Item>

                    <Signature
                      fieldName="consent_witness_signature"
                      label="Signature of Witness (if applicable)"
                      form={props.form}
                      optional={true}
                    />
                  </div>
                )}
            </div>
          )}
          {([site_025, site_026, site_030, site_40].includes(props.site_code)) && <div>
            <p>A signed copy of this consent form has been given to you to keep for your records and reference.</p>
            <br/>
          </div>}

          {[site_026].includes(props.site_code) && isPatient  && <div>
            {(!isEmail || props.signature_type === "participant") && (
              <div>
                <h5>Authorization:</h5>
                <p>I have been given the information about the use and disclosure of my health information for this research study. My questions have been answered.</p>
                <p>I authorize the use and disclosure of my health information to the parties listed in the authorization section of this consent for the purposes described above.</p>

                <h5 style={{ margin: '15px 0', textDecoration: 'underline' }}>AUTHORIZATION SIGNATURE</h5>
                <Signature
                  fieldName="subject_authorization_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:Signature of Subject`
                  )}
                  form={props.form}
                />
              </div>
            )}
          </div>}

          {[site_030].includes(props.site_code) && isPatient && <div>
            {(!isEmail || props.signature_type === "participant") && (
              <div>
                <h5>Authorization:</h5>
                <p>I have been given the information about the use and disclosure of my health information for this research study. My questions have been answered.</p>
                <p>I authorize the use and disclosure of my health information to the parties listed in the authorization section of this consent for the purposes described above.</p>

                <h5 style={{ margin: '15px 0', textDecoration: 'underline' }}>AUTHORIZATION SIGNATURE</h5>
                <Signature
                  fieldName="subject_authorization_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:Signature of Subject`
                  )}
                  form={props.form}
                />
              </div>
            )}
          </div>}


          {[site_030].includes(props.site_code) && isSurrogate && <div>
            <div>
              <h5>Authorization:</h5>
              <p>I have been given the information about the use and disclosure of my health information for this research study. My questions have been answered.</p>
              <p>I authorize the use and disclosure of my health information to the parties listed in the authorization section of this consent for the purposes described above.</p>

              <h5 style={{ margin: '15px 0', textDecoration: 'underline' }}>AUTHORIZATION SIGNATURE</h5>

              {props.consentPersonType === "Surrogate" && (
                <div>
                  <Form.Item>
                    <label>
                      <div className="form-label">
                        {this.props.i18n.t(
                          `NamespaceConsentStep3aPatient:Name of Subject`
                        )}
                      </div>
                      {props.form.getFieldDecorator("extra_field_lar_authorization_subject_full_name", {
                        initialValue: props.extra_field_lar_authorization_subject_full_name,
                        rules: [
                          {
                            required: true,
                            message: "Required",
                          },
                        ],
                      })(
                        <Input
                          disabled={props.signature_type === "investigator"}
                          prefix={<Icon type="user" style={{ color: "#000" }} />}
                          placeholder={this.props.i18n.t(
                            `NamespaceConsentStep3aPatient:Name of Subject`
                          )}
                        />
                      )}
                    </label>
                  </Form.Item>

                  <Form.Item>
                    <label>
                      <div className="form-label">
                        {this.props.i18n.t(
                          `NamespaceConsentStep3aPatient:Relationship to subject`
                        )}
                      </div>
                      {props.form.getFieldDecorator(
                        "extra_field_lar_authorization_representative_relationship",
                        {
                          initialValue: props.extra_field_lar_authorization_representative_relationship,
                        }
                      )(
                        <Input
                          disabled={props.signature_type === "investigator"}
                          placeholder={this.props.i18n.t(
                            `NamespaceConsentStep3aPatient:Relationship to subject`
                          )}
                        />
                      )}
                    </label>
                  </Form.Item>

                  <Form.Item>
                    {props.signature_type === "investigator" && props.authorization_representative_signature && <img src={props.authorization_representative_signature} width={250} alt='LAR Authorization Signature' />}
                  </Form.Item>


                  {(!isEmail || props.signature_type === "participant") && (
                    <Signature
                      fieldName="authorization_representative_signature"
                      label={this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:Signature of Legally Authorized Representative`
                      )}
                      form={props.form}
                    />
                  )}
                </div>
              )}
            </div>
          </div>}

          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(
                  "NamespaceConsentStep3aPatient:Please CONFIRM that the data entered above is correct and complete!"
                )}
              </div>
              {props.form.getFieldDecorator("consent_provided", {
                initialValue: props.consent_provided,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:Please CONFIRM that the data entered above is correct and complete!"
                    ),
                  },
                ],
              })(
                <Select>
                  <Option value="yes">{this.props.i18n.t("Yes")}</Option>
                  <Option value="">{this.props.i18n.t("No")}</Option>
                </Select>
              )}
            </label>
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentMevoStep3aPatient);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevo/ConsentMevoStep3aPatient.js